import 'bootstrap/dist/css/bootstrap.min.css';
import Navigation from "../components/navigation";
import Header from "../components/header";
import React, {useEffect, useRef, useState} from "react";
import {convertFileToBase64, parseContactTypeEmail} from "../utils/utils";
import {encryptMessage, extractEmail} from "../mail/utils";
import StateManager from "../redux/StateManager"
import clsx from 'clsx';
import Styles from "../styles/main.module.css"
import {
    fetchPublicKeys,
    findExternalReceivers, listAliases,
    registerExternalUsers,
    sendMessageToBackend
} from "../server-calls/index";
import _ from "lodash";
import "react-toastify/dist/ReactToastify.css";
import {toast, ToastContainer} from 'react-toastify';
import {useLocation} from "react-router-dom";
import Modal from 'react-modal';
import StandardTextInput from "../components/basic/StandardTextInput";
import StandardButton from "../components/basic/StandardButton";
import HtmlEditor from "../components/basic/HtmlEditor";
import StandardDropDown from "../components/basic/StandardDropDown";
import EmailTagInput from "../components/basic/EmailTagInput";
import {fetchContactsSuggestionsFromCache, fetchUserAccountsFromCache, updateCache} from "../idb";
import FileUploader from "../components/basic/FileUploader";
import "react-toastify/dist/ReactToastify.css";
import {useNavigation} from "../hooks/navigation"


export default function Compose() {
    const {redirect} = useNavigation()
    const TOAST_CONTAINER_ID = "compose-toast-container"

    const navigationRef = useRef()

    const startSocket = () => {
        if (StateManager.isCacheComplete())
            navigationRef.current?.handleSocket()
    }

    const passphraseModalStyles = {
        content: {
            width: "400px",
            height: "320px",
            margin: "auto",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        },
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        }
    };


    let [passphrase, setPassphrase] = useState("");
    let [toList, setToList] = useState([]);
    let [ccList, setCcList] = useState([]);
    let [bccList, setBccList] = useState([]);
    let [messageBody, setMessageBody] = useState("");
    let [subject, setSubject] = useState("");
    let [isHtml] = useState(true);
    let [isEncrypt, setIsEncrypt] = useState(false);
    let [attachments, setAttachments] = useState([]);
    let [isBusy, setIsBusy] = useState(false)
    let subjectRef = useRef(null)
    let [replyToBody, setReplyToBody] = useState("")
    let [forwardBody, setForwardBody] = useState("")
    let [from, setFrom] = useState("")
    const location = useLocation();
    let [isReply, setIsReply] = useState(false);
    let [isReplyAll, setIsReplyAll] = useState(false)
    let [isForward, setIsForward] = useState(false)
    let [isPassphraseModalOpen, setIsPassphraseModalOpen] = useState(false)
    let [isPassphraseError, setIsPassphraseError] = useState(false)
    let [passphraseError, setPassphraseError] = useState("")
    let [externalEmails, setExternalEmails] = useState({to: [], cc: [], bcc: []})
    let [originalExternalEmails, setOriginalExternalEmails] = useState([])
    let [externalEncrypted, setExternalEncrypted] = useState(false)
    let [externalAccounts, setExternalAccounts] = useState([])
    let [fromAccounts, setFromAccounts] = useState([])
    let [toSuggestions, setToSuggestions] = useState([])
    let [ccSuggestions, setCcSuggestions] = useState([])
    let [bccSuggestions, setBccSuggestions] = useState([])
    let [ccEnabled, setCcEnabled] = useState(false)
    let [bccEnabled, setBccEnabled] = useState(false)

    function stateUpdateCcEnabled(){
        if(ccEnabled){
            setCcEnabled(false)
            setCcList([])
        }else{
            setCcEnabled(true)
        }
    }

    function stateUpdateBccEnabled(){
        if(bccEnabled){
            setBccEnabled(false)
            setBccList([])
        }else{
            setBccEnabled(true)
        }
    }

    const handleExternalEncrypted = (value) => {
        externalEncrypted = value
        setExternalEncrypted(externalEncrypted)
    }

    const handleOriginalExternalEmailsInState = (value) => {
        originalExternalEmails = value
        setOriginalExternalEmails(originalExternalEmails)
    }

    const handleExternalEmailsInState = (to, cc, bcc) => {
        externalEmails.bcc = bcc
        externalEmails.to = to
        externalEmails.cc = cc
        setExternalEmails(externalEmails)
    }

    const handlePassphraseInState = (value) => {
        passphrase = value
        setPassphrase(passphrase)
    }

    const handleIsPassphraseErrorInState = (value) => {
        isPassphraseError = value
        setIsPassphraseError(isPassphraseError)
    }

    const handlePassphraseErrorInState = (value) => {
        passphraseError = value
        setPassphraseError(passphraseError)
    }

    const handleIsReplyState = (value) => {
        isReply = value
        setIsReply(isReply)
    }

    const handleIsReplyAllState = (value) => {
        isReplyAll = value
        setIsReplyAll(isReplyAll)
    }

    const handleIsForwardState = (value) => {
        isForward = value
        setIsForward(isForward)
    }

    let [referenceMessageData, setReferenceMessageData] = useState({});

    function handleReferenceMessageData(value) {
        referenceMessageData = value
        setReferenceMessageData(referenceMessageData);
    }

    async function suggestTo(value) {
        setToSuggestions(await fetchSuggestions(value))
    }

    async function fetchSuggestions(value) {
        if (!value) {
            return []
        }
        let suggestions = await fetchContactsSuggestionsFromCache(value)
        let cleaned = []
        suggestions.forEach((suggestion) => {
            cleaned.push({label: suggestion, value: suggestion})
        })
        return cleaned
    }

    async function suggestCc(value) {
        setCcSuggestions(await fetchSuggestions(value))
    }

    async function suggestBcc(value) {
        setBccSuggestions(await fetchSuggestions(value))
    }

    async function startingOperations() {
        const queryParams = new URLSearchParams(location.search);
        handleIsReplyState(queryParams.get('isReply') === 'true')
        handleIsReplyAllState(queryParams.get('isReplyAll') === 'true')
        handleIsForwardState(queryParams.get('isForward') === 'true')
        if (isReply) {
            performReplyOperation(false)
        } else if (isReplyAll) {
            performReplyOperation(true)
        } else if (isForward) {
            performForwardOperation()
        }

        let accounts
        if (StateManager.isCacheDbSetupComplete()) {
            accounts = await fetchUserAccountsFromCache()
        } else {
            accounts = await listAliases(StateManager.getToken(), {})
        }
        let properAccounts = []
        accounts.forEach((account) => {
            properAccounts.push({text: account.email, value: account.email})
        })
        setFromAccounts(properAccounts)
        if (isReply) {
            console.log(`is a reply sir g`)
            setFrom(referenceMessageData.intendedFor)
        } else {
            console.log(`is not a reply sir g`)
            setFrom(properAccounts[0].value)
        }
        startSocket()
    }

    useEffect(() => {
        startingOperations()
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [location.search]);


    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);


    const performReplyOperation = (replyAll = false) => {
        handleReferenceMessageData(StateManager.renderedMailData())
        console.log(referenceMessageData)
        setReplyToBody(`<br><br>${generateReplyHtml(referenceMessageData.decryptedBody, extractEmail(referenceMessageData.from), referenceMessageData.date)}`)
        if (!referenceMessageData.decryptedSubject.startsWith("Re")) {
            handleOperationSubject(`Re: ${referenceMessageData.decryptedSubject}`)
        } else {
            handleOperationSubject(referenceMessageData.decryptedSubject)
        }

        setFrom(referenceMessageData.intendedFor)
        setReceiversForReplyOperation(replyAll, referenceMessageData)
    }

    function setReceiversForReplyOperation(replyAll = false, referencedMessageData) {
        if (referencedMessageData.from.includes(StateManager.getUserEmail())) {
            let toList = parseToEmails(referencedMessageData.to)
            if (replyAll) {
                let userIndex = toList.indexOf(StateManager.getUserEmail())
                if (userIndex > -1) {
                    delete toList[userIndex]
                }
                handleToList(toList)
            } else {
                handleToList([toList[0]])
            }
        } else {
            handleToList(parseToEmails(referencedMessageData.from))
        }

        if (replyAll) {
            let list = parseToEmails(referencedMessageData.cc)
            let userIndex = list.indexOf(StateManager.getUserEmail())
            if (userIndex > -1) {
                delete list[userIndex]
            }
            handleCcList(list)
        }
    }

    const performForwardOperation = () => {
        handleReferenceMessageData(StateManager.renderedMailData())
        setForwardBody(`<br><br>${generateForwardHtml(referenceMessageData.decryptedBody, extractEmail(referenceMessageData.from), referenceMessageData.date)}`)
        if (!referenceMessageData.decryptedSubject.startsWith("Fw")) {
            handleOperationSubject(`Fw: ${referenceMessageData.decryptedSubject}`)
        } else {
            handleOperationSubject(referenceMessageData.decryptedSubject)
        }
    }

    function handleOperationSubject(subject) {
        handleSubject(subject)
        subjectRef.current.value = subject
    }

    const parseToEmails = (to) => {
        let emails = []
        if (to.includes(",")) {
            to = to.replaceAll(" ", "")
            let parts = _.split(to, ",")
            parts.forEach((part) => {
                emails.push(parseContactTypeEmail(part))
            })
            return emails
        } else {
            return [parseContactTypeEmail(to)]
        }
    }


    const inputWrapperStyle = {
        display: 'flex',
        flexWrap: 'wrap',
        padding: '10px',
        marginLeft: "10px",
        border: '1px solid #ccc',
        borderRadius: '4px',
        width: "49vh"
    };

    const inputStyle = {
        border: 'none',
        outline: 'none',
        flexGrow: 1,
    };

    const handleToList = (emails) => {
        console.log("////////////////////////////////////////////////////////")
        console.log(emails)
        setToList(emails)
    }

    const handleCcList = (emails) => {
        if (emails.length > 0 && !ccEnabled) {
            setCcEnabled(true)
        } else {
            setCcList(false)
        }
        setCcList(emails)
    }

    const handleBccList = (emails) => {
        if (emails.length > 0 && !bccEnabled) {
            setBccEnabled(true)
        } else {
            setBccEnabled(false)
        }
        setBccList(emails)
    }

    const handleIsBusy = (value) => {
        isBusy = value
        setIsBusy(isBusy)
    }

    const handleFileUpload = async (files) => {
        let built = []
        for (let i = 0; i < files.length; i++) {
            let type = files[i].type
            if (_.isEmpty(type))
                type = "text/plain"
            built.push({
                name: files[i].name,
                content: await convertFileToBase64(files[i]),
                type
            })
        }
        attachments = built
        setAttachments(attachments);

        console.log(attachments)

    };

    const handleEncryptChange = () => {
        setIsEncrypt(!isEncrypt);
    };

    const handleSubject = (value) => {
        subject = value
        setSubject(subject)
    }

    const handleBody = (value) => {
        messageBody = value
        setMessageBody(messageBody)
    }

    const handlePassphraseModalOpenClose = () => {
        isPassphraseModalOpen = !isPassphraseModalOpen;
        setIsPassphraseModalOpen(isPassphraseModalOpen)
    }


    const sendMessage = async () => {
        if (_.isEmpty(toList)) {
            toast.error(`please enter addresses properly`, {containerId: TOAST_CONTAINER_ID})
            return
        }


        if (isEncrypt) {
            let body = {}
            if (!_.isEmpty(toList)) {
                body.to = toList
            }

            if (!_.isEmpty(ccList)) {
                body.cc = ccList
            }

            if (!_.isEmpty(bccList)) {
                body.bcc = bccList
            }


            let externalAccounts = await findExternalReceivers(StateManager.getToken(), body)
            setExternalAccounts(externalAccounts)
            const toExternalEmails = externalAccounts.to
            const ccExternalEmails = externalAccounts.cc
            const bccExternalEmails = externalAccounts.bcc

            if (!_.isEmpty(toExternalEmails) || !_.isEmpty(ccExternalEmails) || !_.isEmpty(bccExternalEmails)) {
                handleExternalEncrypted(true)
                handlePassphraseModalOpenClose()
            } else {
                return proceedWithSendMessage()
            }
        } else {
            return proceedWithSendMessage()
        }
    }

    const proceedEncryptedMailSendWithPassphrase = async () => {

        if (_.isEmpty(passphrase)) {
            handleIsPassphraseErrorInState(true)
            handlePassphraseErrorInState("Please enter passphrase.")
        } else if (passphrase.length < 8) {
            handleIsPassphraseErrorInState(true)
            handlePassphraseErrorInState("Passphrase should be minimum 8 chars")
        }

        handlePassphraseModalOpenClose()

        let toExternalEmails = externalAccounts.to
        let ccExternalEmails = externalAccounts.cc
        let bccExternalEmails = externalAccounts.bcc

        if (!_.isEmpty(toExternalEmails)) {
            toExternalEmails.forEach((email) => {
                let existingIndex = toList.indexOf(email)
                if (existingIndex > -1) {
                    toList.splice(existingIndex, 1)
                }
            })
        }

        if (!_.isEmpty(ccExternalEmails)) {
            ccExternalEmails.forEach((email) => {
                let existingIndex = ccList.indexOf(email)
                if (existingIndex > -1) {
                    ccList.splice(existingIndex, 1)
                }
            })
        }

        if (!_.isEmpty(bccExternalEmails)) {
            bccExternalEmails.forEach((email) => {
                let existingIndex = bccList.indexOf(email)
                if (existingIndex > -1) {
                    bccList.splice(existingIndex, 1)
                }
            })
        }

        handleCcList(ccList)
        handleToList(toList)
        handleBccList(bccList)

        handleExternalEmailsInState(toExternalEmails, ccExternalEmails, bccExternalEmails)

        toast.loading("registering external users", {containerId: TOAST_CONTAINER_ID})

        let resp = await registerExternalUsers(StateManager.getToken(), {
            to: externalEmails.to,
            cc: externalEmails.cc,
            bcc: externalEmails.bcc,
            passphrase: passphrase
        })

        let originalExternalEmails = []

        if (!_.isEmpty(resp.to)) {

            resp.to.forEach((emailObj) => {
                toList.push(emailObj.ourCreated)
                originalExternalEmails.push(emailObj)
            })
        }

        if (!_.isEmpty(resp.cc)) {
            resp.cc.forEach((emailObj) => {
                ccList.push(emailObj.ourCreated)
                originalExternalEmails.push(emailObj)
            })
        }

        if (!_.isEmpty(resp.bcc)) {

            resp.bcc.forEach((emailObj) => {
                bccList.push(emailObj.ourCreated)
                originalExternalEmails.push(emailObj)
            })
        }

        handleOriginalExternalEmailsInState(originalExternalEmails)

        handleToList(toList)
        handleCcList(ccList)
        handleBccList(bccList)

        toast.dismiss({containerId: TOAST_CONTAINER_ID})

        return proceedWithSendMessage()

    }

    const cancelPassphraseModal = () => {
        toast.dismiss({containerId: TOAST_CONTAINER_ID})
        handlePassphraseModalOpenClose()
    }

    const proceedWithSendMessage = async () => {
        toast.loading("sending message", {containerId: TOAST_CONTAINER_ID})
        try {

            if (_.isEmpty(toList)) {
                toast.error(`Please enter addresses properly.`)
            }

            let backendCallBody = {
                to: toList,
                cc: ccList,
                bcc: bccList,
                message: messageBody,
                subject: subject,
                isHtml,
                attachments,
                isEncrypted: isEncrypt,
                from: from

            }

            if (externalEncrypted) {
                backendCallBody.externalEncrypted = true
                backendCallBody.passphrase = passphrase
                backendCallBody.externalEmails = originalExternalEmails
            }

            if (isReply || isReplyAll) {
                backendCallBody.replyTo = referenceMessageData.messageId
                backendCallBody.replyToUid = referenceMessageData.uid
                backendCallBody.references = referenceMessageData.messageId
                if (!_.isEmpty(referenceMessageData.references))
                    backendCallBody.references = backendCallBody.references + " " + referenceMessageData.references
                backendCallBody.isAReply = true
            } else if (isForward) {
                backendCallBody.isForward = true
            }

            if (isEncrypt) {
                let receivers = collectReceivers()
                receivers.push(StateManager.getUserEmail())

                console.log(receivers)

                let publicKeys = await fetchPublicKeys(receivers, StateManager.getToken())
                publicKeys = publicKeys.found
                console.log(publicKeys)
                try {
                    const {body, encryptedSubject} = await encryptMessage({
                        body: messageBody,
                        subject,
                        isHtml,
                        attachments,
                        publicKeys
                    })

                    console.log(body, encryptedSubject)

                    backendCallBody.message = body
                    backendCallBody.subject = encryptedSubject
                    backendCallBody.isEncrypted = true
                    backendCallBody.isHtml = isHtml
                    backendCallBody.attachments = []
                } catch (error) {
                    toast.dismiss({containerId: TOAST_CONTAINER_ID})
                    toast.error("error encrypting message", {containerId: TOAST_CONTAINER_ID})
                    console.error(error)
                }
            }


            console.log(backendCallBody)

            await sendMessageToBackend(backendCallBody, StateManager.getToken())
            handleIsBusy(false)
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.success("message sent", {containerId: TOAST_CONTAINER_ID})
            setTimeout(() => {
                redirect("/mail")
            }, 1000)
        } catch (e) {
            toast.dismiss({containerId: TOAST_CONTAINER_ID})
            toast.error("error sending message", {containerId: TOAST_CONTAINER_ID})
            console.log(e)
        }
    }

    function generateReplyHtml(originalBody, originalSender, originalDate) {
        const date = new Date(originalDate).toLocaleString();

        const isHtml = /<\/?[a-z][\s\S]*>/i.test(originalBody.trim());

        let safeHtmlBody;
        if (isHtml) {
            safeHtmlBody = originalBody;
        } else {
            const escaped = originalBody
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            safeHtmlBody = `<pre style="margin: 0; padding: 0; white-space: pre-wrap;">${escaped}</pre>`;
        }

        return `<p>On ${date}, ${originalSender} wrote:</p>
    <blockquote style="margin: 0; padding-left: 10px; border-left: 2px solid #ccc;">
        ${safeHtmlBody}
    </blockquote>`;
    }

    function generateForwardHtml(originalBody, originalSender, originalDate) {
        const date = new Date(originalDate).toLocaleString();

        const isHtml = /<\/?[a-z][\s\S]*>/i.test(originalBody.trim());

        let safeHtmlBody;
        if (isHtml) {
            safeHtmlBody = originalBody;
        } else {
            const escaped = originalBody
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            safeHtmlBody = `<pre style="margin: 0; padding: 0; white-space: pre-wrap;">${escaped}</pre>`;
        }

        return `<p>------------Forwarded Message-------------</p>
                <p>From: ${originalSender}</p>
                <p>Date: ${date}</p>
                <blockquote style="margin: 0; padding-left: 10px; border-left: 2px solid #ccc;">
                ${safeHtmlBody}
                </blockquote>`;
    }


    function collectReceivers() {
        let receivers = []
        toList.forEach((email) => {
            receivers.push(email)
        })
        ccList.forEach((email) => {
            receivers.push(email)
        })
        bccList.forEach((email) => {
            receivers.push(email)
        })
        return receivers
    }

    return (
        <>
            <Header></Header>
            <div className="container-fluid"
                 style={isMobile ? {height: '100%', paddingBottom: "80px"} : {height: "100%"}}>
                <div className="row">
                    <div className="d-none d-md-block col-md-1 col-lg-1 col-xl-1 p-0">
                        <Navigation
                            handlerFunction={updateCache}
                            ref={navigationRef}
                        />
                    </div>
                    <div
                        style={{
                            ...(isMobile
                                ? {
                                    height: "100%",
                                    overflowY: "visible",
                                    paddingBottom: "80px", // 👈 Add this
                                }
                                : {
                                    maxHeight: "95vh",
                                    overflowY: "scroll"
                                }),
                            overflowX: "hidden"
                        }}
                        className="col-md-11 col-lg-11 col-xl-11 p-0"
                    >
                        <div style={{width: "100vh", marginLeft: "15px", marginTop: "15px"}}>
                            <div className="col-md-12 col-lg-12 col-xl-12">
                                <div className="form-group row align-items-center mb-3">
                                    <span className="col-sm-2 col-form-label">From:</span>
                                    <div className="col-sm-12 col-md-6 email-input-wrapper" style={inputWrapperStyle}>
                                        <StandardDropDown
                                            selectedValue={from}
                                            customStyles={{height: "100%", width: "100%"}}
                                            options={fromAccounts}
                                            onChange={(e) => setFrom(e.target.value)}
                                        />
                                    </div>
                                </div>

                                {/* To Field */}
                                <div className="form-group row align-items-center mb-3">
                                    <span className="col-sm-2 col-form-label">To:</span>
                                    <div style={{width: "50%"}}>
                                        <EmailTagInput defaultEmails={toList} suggestSomething={suggestTo}
                                                       suggestions={toSuggestions}
                                                       onChange={handleToList} styles={{width: "20px"}}/>
                                    </div>
                                </div>
                                <div className="form-group row align-items-center mb-3">
                                    <button className="btn btn-outline-secondary" style={{padding:"0 1px", marginLeft: "20%", height:"25px", width: "80px"}} onClick={stateUpdateCcEnabled}>
                                        <i className={ccEnabled ? "fa fa-minus":"fa fa-plus"}></i> CC
                                    </button>
                                </div>
                                {/* CC Field */}
                                <div style={{display: ccEnabled ? "flex" : "none"}}
                                     className="form-group row align-items-center mb-3">
                                    <span className="col-sm-2 col-form-label">Cc:</span>
                                    <div style={{width: "50%"}}>
                                        <EmailTagInput defaultEmails={ccList} suggestSomething={suggestCc}
                                                       suggestions={ccSuggestions}
                                                       onChange={handleCcList} styles={{width: "20px"}}/>
                                    </div>
                                </div>
                                <div className="form-group row align-items-center mb-3">
                                    <button className="btn btn-outline-secondary" style={{padding:"0 1px", marginLeft: "20%", height:"25px", width: "80px"}} onClick={stateUpdateBccEnabled}>
                                        <i className={bccEnabled ? "fa fa-minus":"fa fa-plus"}></i> BCC
                                    </button>
                                </div>
                                {/* BCC Field */}
                                <div style={{display: bccEnabled ? "flex" : "none"}}
                                     className="form-group row align-items-center mb-3">
                                    <span className="col-sm-2 col-form-label">Bcc:</span>
                                    <div style={{width: "50%"}}>
                                        <EmailTagInput defaultEmails={bccList} suggestSomething={suggestBcc}
                                                       suggestions={bccSuggestions}
                                                       onChange={handleBccList} styles={{width: "20px"}}/>
                                    </div>
                                </div>

                                <div className="form-group row align-items-center mb-3">
                                    <span className="col-sm-2 col-form-label">Subject:</span>
                                    <div className="col-sm-6 email-input-wrapper" style={inputWrapperStyle}>
                                        <input
                                            ref={subjectRef}
                                            type="text"
                                            onChange={(e) => handleSubject(e.target.value)}
                                            placeholder="Subject"
                                            style={inputStyle}
                                        />
                                    </div>
                                </div>

                                <div className={clsx("row align-items-center mb-3", Styles.ComposeMessageField)}>
                                    <HtmlEditor
                                        replyHtml={isForward ? forwardBody : replyToBody}
                                        onChange={(content, delta, source, editor) => {
                                            handleBody(editor.getHTML()); // always returns HTML
                                        }}
                                    />
                                </div>
                                <br></br><br></br>

                                <div className="form-group row align-items-center mb-3">
                                    <div className="col-sm-6 offset-sm-2">
                                        <div className="col-sm-12">
                                            <input
                                                type="checkbox"
                                                checked={isEncrypt}
                                                onChange={handleEncryptChange}
                                            />
                                            <label className="ml-2">Encrypt Message</label>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className={clsx("form-group row align-items-center mb-3", Styles.ComposeMessageField)}>
                                    <div className="col-sm-6 offset-sm-2">
                                        <FileUploader
                                            onFilesChange={handleFileUpload}
                                        />
                                    </div>
                                </div>


                                <div className="d-none d-md-block form-group row align-items-center mb-3">
                                    <div className="col-sm-6 offset-sm-2">
                                        <button className='btn btn-primary' onClick={sendMessage}
                                                disabled={isBusy}>
                                            Send Message
                                        </button>
                                    </div>
                                </div>

                                <div className="d-block d-md-none fixed-bottom bg-light border-top py-2 px-3">
                                    <button
                                        className="btn btn-primary w-100"
                                        onClick={sendMessage}
                                        disabled={isBusy}
                                    >
                                        Send Message
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal style={passphraseModalStyles} isOpen={isPassphraseModalOpen}>
                <p>There are Some external recipients and email encrypt option is true. Please enter passphrase for
                    external accounts.</p>
                <StandardTextInput onChange={handlePassphraseInState}
                                   placeholder={"Passphrase, min 8 chars."}/><br></br>
                <StandardButton onClick={proceedEncryptedMailSendWithPassphrase}
                                customStyles={{backgroundColor: "Green"}} innerText={"Proceed"}/>&nbsp;
                <StandardButton customStyles={{backgroundColor: "Red"}} onClick={cancelPassphraseModal}
                                innerText={"Cancel"}/><br></br><br></br>
                {isPassphraseError && (<p style={{color: "red"}}>{passphraseError}</p>)}
            </Modal>

            <ToastContainer containerId={TOAST_CONTAINER_ID}/>
        </>
    );
}
